import React from 'react';

export const ScribblesTopLeft = () => {
  return (
    <svg
      width="81"
      height="65"
      viewBox="0 0 81 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="scribbles scribbles-top-left"
    >
      <path
        d="M4.05199 17.7266C6.43325 19.2182 10.4755 19.9382 14.2628 20.2767C17.5279 20.5684 18.9205 16.6779 16.4007 14.5811C14.2737 12.8113 12.237 11.1167 11.2112 10.2636C8.52228 8.02736 3.88134 7.47191 1.39523 10.3345C-1.09087 13.1971 2.44592 16.7205 4.05199 17.7266Z"
        fill="#7D9FE8"
      />
      <path
        d="M6.37995 38.4493C8.80383 37.948 11.8998 35.5052 14.1191 33.4918C15.1874 32.5225 14.4201 30.864 12.981 30.9643C10.4137 31.1431 7.32743 31.3581 6.03891 31.4482C3.65227 31.6151 1.18193 33.5179 1.43559 36.0815C1.68926 38.6451 5.11893 38.7101 6.37995 38.4493Z"
        fill="#7D9FE8"
      />
      <path
        d="M22.0273 60.4475C27.9561 50.2099 28.634 42.6618 33.5966 33.0483C34.2611 31.761 36.1287 32.1271 36.3465 33.5592C36.4692 34.3659 36.5882 35.1339 36.7006 35.8673C36.9772 37.6714 41.6977 38.7629 42.2649 37.0281C43.8794 32.0906 45.0581 27.0711 46.6053 23.0646C47.1246 21.7198 48.8547 22.0168 49.0776 23.4411C49.7577 27.7863 50.4498 31.5996 51.0598 34.5354C51.3392 35.8802 53.018 36.1016 53.5663 34.8422C56.0174 29.212 57.4733 22.3242 59.3196 16.7103C59.7894 15.2817 61.5955 15.5033 61.7704 16.997C62.172 20.426 62.3614 23.3598 62.6701 25.8176C62.8513 27.2604 64.45 27.3166 64.7961 25.9042C66.4215 19.2713 67.0786 11.8126 71.3236 4.0604"
        stroke="#7D9FE8"
        strokeWidth="7.17093"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ScribblesBottomRight = () => {
  return (
    <svg
      width="79"
      height="91"
      viewBox="0 0 79 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="scribbles scribbles-bottom-right"
    >
      <path
        d="M12.5004 60.7493C19.8875 56.2235 7.14086 92.64 16.5 85.75C22.9212 81.0228 18.9306 54.0124 28.0399 48.0318C37.1491 42.0512 21.4313 79.2403 32 73.75C39.7547 69.7216 35.1677 42.4512 44.4999 37.7498C53.8322 33.0485 33.8513 69.6379 44.4999 64.25C52.8648 60.0176 70.1797 24.214 60.9999 28.2498C51.8201 32.2856 48.5 57.0658 57.5 55.25C66.5 53.4342 71.5 44.25 73.5 37.7498"
        stroke="#7D9FE8"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.642 8.07618C74.7368 10.8912 71.0544 13.2743 68.0952 14.8612C66.366 15.7884 64.573 14.1491 65.1913 12.287C66.1625 9.36245 67.35 5.82748 67.9898 4.07566C68.8674 1.67264 71.7443 0.0240269 74.8049 2.09492C77.8656 4.16581 77.6774 6.54635 76.642 8.07618Z"
        fill="#7D9FE8"
      />
    </svg>
  );
};
